import React from 'react';
import { Grid } from '@material-ui/core';
export const InlineFormContent = props => {
    const { children } = props;
    return (React.createElement(Grid, Object.assign({ item: true }, props), children));
};
//# sourceMappingURL=InlineFormContent.js.map